/*
Search: hands off to Ghost's own sodo-search overlay. Ghost binds anything with
a `#/search` href or the data-ghost-search attribute; we just make the button
work when the overlay script hasn't attached yet.
*/

export default function search() {
    document.querySelectorAll('[data-ghost-search]').forEach((el) => {
        el.addEventListener('click', () => {
            window.location.hash = '/search';
        });
    });
}
